// LiveStreamChatHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

export class LiveStreamChatHandler extends React.PureComponent {
  componentWillUnmount() {
    const { clearLiveStreamChatQueue } = this.props;

    clearLiveStreamChatQueue();
  }
  render() {
    return null;
  }
}

LiveStreamChatHandler.propTypes = {
  clearLiveStreamChatQueue: PropTypes.func,
};

LiveStreamChatHandler.defaultProps = {
  clearLiveStreamChatQueue: () => null,
};

export default LiveStreamChatHandler;
